module.exports = __webpack_public_path__ + "img/25 aprender.ffd9abe9.jpg";